import { useBlocker } from '@tanstack/react-router';
import { useState } from 'react';

export const useLeaveBlocker = () => {
  const [isBlocking, setIsBlocking] = useState(true);

  const initBlocking = () => {
    useBlocker({
      shouldBlockFn: () => {
        if (!isBlocking) return false;

        // ページ遷移＆ブラウザバック時には以下のメッセージを表示
        // リフレッシュ＆タブクローズ時はブラウザのデフォルトメッセージが表示される
        const result = confirm(
          '変更が保存されない可能性がありますが、ページを移動しますか？',
        );
        return !result;
      },
      enableBeforeUnload: isBlocking,
    });
  };

  const unBlocking = () => setIsBlocking(false);

  const onBlocking = () => setIsBlocking(true);

  return {
    initBlocking,
    unBlocking,
    onBlocking,
  };
};
